import { Component, OnInit, ChangeDetectorRef, NgZone } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { ApiHelper } from "../../_helpers/api.helper";
import { CommonHelper } from "../../_helpers/common.helper";
import { ConstantHelper } from "../../_helpers/constant.helper";
import { AppConfig } from "../../app.config";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { UserService } from "../../_services/user.service";
import { TextService } from "./textService";
import axios from "axios";
import { Injectable } from "@angular/core";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { Location } from '@angular/common';

import { EMPTY, interval, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
declare var bootstrap: any;
@Component({
  selector: "app-admin-practice-dictation",
  templateUrl: "./admin-practice-dictation.component.html",
  styleUrls: ["./admin-practice-dictation.component.scss"],
})
@Injectable({
  providedIn: "root",
})
export class AdminPracticeDictationComponent implements OnInit {
  resultJsonObj: any = {};

  loggedInUserId: string;
  loggedInUserRoleId: any;
  demographyUserId: string;
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  childRoute: string;
  documentsList: any;
  patientName: any;
  patient_email: any;
  showActionCommentModal = false;
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  httpOptions = { headers: this.httpHeaders };
  showLoader = false;
  message = Message;
  initiatedBy: any;
  admins: any = [];
  userRoleVal: any = 0;
  selectedAdminForComment: any;
  selectedPhysicianForComment: any;
  showAllData = 1;

  dictationList: any = [];
  sharedDictationList: any = [];
  selectedComment: any = {};
  dtOptions: DataTables.Settings = {};
  patientTranscribeListFlag: boolean = false;
  showDataVal: any = 1;
  fetchedText: any = "";
  showEditsummaryModal: boolean = false;
  editSummaryFlag: boolean = false;
  commentId: any;
  showAiSummaryModal: boolean = false;
  showShareSummaryModal: boolean = false;
  isSummarySigned: any = 0;
  isSummaryEdited: any = 0;
  showSignedAiSummaryModal: boolean = false;

  practices: any;
  physicians1: any;
  tempPhysician01: any = [];
  physicianInfo1: any = "";
  tempPractice01: any = [];
  practiceInfo1: any = "";
  finalPhysician01: any = [];
  selectedPhysiciansIdList: any = [];
  shareVisitSummariesFlag: boolean = false;
  isDelegating: any = 0;
  delegateId: any = 0;
  physicianName: any;
  showAiDictationModalPopup: boolean = false;
  chatBotVisible: boolean = false;
  patientId: string = ""; // Assuming this is where you store the patientId
  isPopUp: boolean = false; // Assuming this is a boolean value for isPopUp
  propValue: any;
  transcribeResponse: any;
  transcribeApiUrl: string = "";
  // private transcribeApiUrl = "https://app-dev-ashchatgpt.azurewebsites.net/transcribe_whisper"; 
  // private transcribeApiUrl = "http://127.0.0.1:5000/generate_templates"; 
  private pdfTemplateUrl = this.appConfig.getTranscribeApiUrl()+"generate_templates"; 
  // private pdfTemplateUrl = "http://127.0.0.1:5000/generate_templates";
  responseStatus: string | null = null;
  // responseStatus: 'pending' | 'success' | 'error' = 'pending';
  commentStatus: any | null = null;
  transStatus: string | null = null;
  responseMessage: any;
  private isDestroyed = false;
  private pollingSubscription: Subscription | undefined;
  isDictationUploaded = false;
  isDictationStarted: boolean;
  showHtmlModal = false;
  selectedFile: File | null = null;
  generatedHtml: string = '';
  templateName: string = '';
  prescriptionTemplate: boolean = true;
  followUpTemplate: boolean = true;
  appointmentTemplate: boolean = true;
  recordingUrl: any;
  enabledTemplates: any[] = [];
  selectedTemplates: { [id: number]: boolean } = {};
  roleSelections: { [id: number]: { [role: string]: boolean } } = {};
  availableRoles: string[] = [];
  roleEmails: { [role: string]: string } = {};
  editCommentId: any;

  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public sweetAlertHelper: SweetAlertHelper,
    private http: HttpClient,
    public userService: UserService,
    public datepipe: DatePipe,
    private textService: TextService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private location: Location,
    private httpClient: HttpClient,
  ) {
    localStorage.setItem("childRoute", activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
    this.loggedInUserId = this.activatedRoute.snapshot.paramMap.get('loggedInUserId');
    this.loggedInUserRoleId = localStorage.getItem('loggedInUserRoleId');
    this.demographyUserId = this.activatedRoute.snapshot.paramMap.get('demographyUserId');
    this.initiatedBy = localStorage.getItem('loggedInUserName');
    this.isDelegating = localStorage.getItem("isDelegating") ? localStorage.getItem("isDelegating") : 0;
    this.delegateId = localStorage.getItem("delegateId") ? localStorage.getItem("delegateId") : 0;
    this.physicianName = localStorage.getItem('loggedInUserName');
  }

  ngOnInit() {
    this.transcribeApiUrl = this.appConfig.getTranscribeApiUrl() + "transcribe_whisper";
    let empName = localStorage.getItem("loggedInUserName");
    const currentDateTime = format(new Date(), "yyyyMMdd_HHmmss");
    const fileName = `${empName}_${currentDateTime}.mp3`;
    this.responseStatus = sessionStorage.getItem("transcribeStatus");
    console.log("transcribeStatus : ", this.responseStatus);
    this.commentStatus = sessionStorage.getItem("commentId");
    const isPollingActive = sessionStorage.getItem("pollingActive");
    if (this.responseStatus === 'pending' && isPollingActive === 'true' && this.commentStatus) {
      this.startPolling();
    }
    const transcriptionInProgress = sessionStorage.getItem('transcriptionInProgress');
    console.log("transcriptionInProgress: ", transcriptionInProgress)

    this.availableRoles.forEach(role => {
      let saved = '';
      if (this.enabledTemplates.length > 0 && this.enabledTemplates[0]) {
        saved = this.enabledTemplates[0][`${role}_email`] || '';
      }
      this.roleEmails[role] = saved;
    });

    if (transcriptionInProgress) {
      const { recordingUrl, commentId } = JSON.parse(transcriptionInProgress);
      this.regenerateTranscript(recordingUrl, commentId);
    }
    // Request notification permission on component initialization
    this.requestNotificationPermission()
      .then(() => {
        this.showTranscriptionStatusNotification();
      })
      .catch((error) => {
        console.error("Notification permission error:", error);
      });

    if (this.loggedInUserRoleId == 4) {
      this.findDictations();
      this.showData(1);
    } else {
      this.showData(2);
    }
    this.findAdminList();
    this.findUserDetails(this.demographyUserId);
    this.dtOptions = {
      order: [],
    };
    this.getUserPractices();
    this.propValue = { isPopUp: true, patientId: this.demographyUserId };

    window.addEventListener("transcribeStatusUpdate", (event: any) => {
      const detail = event.detail;
      this.zone.run(() => {
        this.updateTranscribeStatus(detail);
        this.handleTranscribeStatusUpdate(detail);
      });
    });
    window.addEventListener("dictationStart", () => {
      this.isDictationStarted = true;
      this.isDictationUploaded = false; // Ensure the close button is disabled until upload completes
    });

    window.addEventListener("dictationUploadSuccess", () => {
      this.isDictationUploaded = true;
    });
  }

  saveEmailsToTemplates() {
    if (this.enabledTemplates.length > 0) {
      this.availableRoles.forEach(role => {
        this.enabledTemplates[0][`${role}_email`] = this.roleEmails[role];
      });
    }
  }



  getEnabledTemplates() {
    const physician_email = localStorage.getItem("loggedInUserEmail");
    const patient_email = localStorage.getItem("patientEmail");
    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.getEnabledTemplatesWithRoles, {}, this.httpOptions)
      .subscribe({
        next: (res: any) => {
          if (res && res.commandResult && res.commandResult.status === 1) {
            this.enabledTemplates = res.commandResult.data;

            if (this.enabledTemplates.length > 0) {
              // Dynamically get role fields from keys of the first template
              const excludeKeys = ['id', 'template_name', 'status'];
              this.availableRoles = Object.keys(this.enabledTemplates[0]).filter(k => !excludeKeys.includes(k));

              // Set defaults
              this.enabledTemplates.forEach(t => {
                this.selectedTemplates[t.id] = true;
                this.roleSelections[t.id] = {};

                this.availableRoles.forEach(role => {
                  this.roleSelections[t.id][role] = !!t[role];
                  // Dynamically assign email for each role (e.g., physician_email)
                  if (role === 'physician') {
                    t[`${role}_email`] = physician_email;  // ✅ inject from frontend
                  } else if (role === 'patient') {
                    t[`${role}_email`] = patient_email;
                  }

                  else {
                    t[`${role}_email`] = ''; // or assign other role emails here
                  }
                });
              });
            }

          }
        },
        error: (err) => {
          console.error('Failed to load enabled templates:', err);
        }
      });
  }


  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && file.name.endsWith('.docx')) {
      this.selectedFile = file;
    } else {
      alert('Please upload a valid .docx file.');
      this.selectedFile = null;
    }
  }

  startPolling() {
    // Mark polling as active
    sessionStorage.setItem("pollingActive", 'true');
    this.pollingSubscription = interval(5000) // Poll every 5 seconds
      .pipe(
        switchMap(() => this.httpClient.get(`${this.transcribeApiUrl}`).pipe(
          // switchMap(() => this.httpClient.get(`http://127.0.0.1:5000/transcribe_whisper`).pipe(
          catchError((error) => {
            console.error("API call failed with error:", error);
            this.zone.run(() => {
              sessionStorage.setItem("transcribeStatus", 'error');
              sessionStorage.setItem("pollingActive", 'false'); // Stop polling
              this.responseStatus = 'error';
              this.stopPolling();
            });
            return EMPTY;
          })
        ))
      )
      .subscribe((status: any) => {
        this.zone.run(() => {
          if (status !== 'pending') {
            sessionStorage.setItem("transcribeStatus", status);
            sessionStorage.setItem("pollingActive", 'false'); // Stop polling
            this.responseStatus = status;
            this.stopPolling();
            this.showTranscriptionStatusNotification();
          }
        });
      });
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
    sessionStorage.setItem("pollingActive", 'false'); // Mark polling as stopped
  }

  updateTranscribeStatus(event: any) {
    const { status } = event;
    const { message } = event;
    this.zone.run(() => {
      this.responseStatus = status;
      this.responseMessage = message;
      sessionStorage.setItem("transcribeStatus", status);
      this.showTranscriptionStatusNotification();
      // Remove responseStatus from sessionStorage after updating the UI
      setTimeout(() => {
        sessionStorage.removeItem("transcribeStatus");
      }, 0);
    });
  }

  handleTranscribeStatusUpdate(event: any): void {
    //from gpt
    const { status } = event;
    const { message } = event;
    this.zone.run(() => {
      this.responseStatus = status;
      this.responseMessage = message;
      sessionStorage.setItem("transcribeStatus", status);
      sessionStorage.setItem("commentStatus", this.commentId);
      // this.updateRecordStatus(this.commentId,status)
      this.showTranscriptionStatusNotification();
      setTimeout(() => {
        sessionStorage.removeItem("transcribeStatus");
        sessionStorage.removeItem("commentStatus");
      }, 0);
    });
  }
  showTranscriptionStatusNotification(): void {
    this.showNotification(this.responseStatus, this.responseMessage);
  }
  showNotification(status: string, message: string) {
    if (!("Notification" in window)) {
      return;
    }
    if (Notification.permission === "granted") {
      new Notification("Transcription Status", { body: message });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification("Transcription Status", { body: message });
        }
      });
    }
    Swal.fire({
      title: status === "success" ? "Please Confirm" : "Error",
      text: message,
      // icon: status === "success" ? "success" : "error",
      confirmButtonText: "OK"
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
  requestNotificationPermission(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!("Notification" in window)) {
        reject("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        // resolve();
        return Promise.resolve(Notification.permission);
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            return Promise.resolve(permission);
          } else {
            return Promise.reject("Notification permission denied");
          }
        });
      } else {
        return Promise.reject("Notification permission denied");
      }
    });
  }

  findUserDetails(demographicUserId) {
    const finalData = {
      id: demographicUserId,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.name_findUserDetailsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.patientName = this.userService.getUS_FromatName(
            apiResponse.commandResult.data.userInfo.FullName
          );
          this.patient_email = apiResponse.commandResult.data.userInfo.Email;
          localStorage.setItem("patientEmail", this.patient_email);
          this.showLoader = false;
        },
        (err) => {
          // console.error(err);
        }
      );
  }

  async findDictations() {
    this.responseStatus = sessionStorage.getItem("transcribeStatus");
    this.commentStatus = sessionStorage.getItem("commentId");
    //alert(this.responseStatus)
    this.dictationList = [];
    this.sharedDictationList = [];
    this.shareVisitSummariesFlag = false;
    const finalData = {
      userId: this.loggedInUserId,
      patientId: this.demographyUserId,
      companySlug: ConstantHelper.COMPANY_SLUG,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.findDictationFiles,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (res: any) => {
          if (res.commandResult.data.Dictations.length > 0) {
            this.dictationList = res.commandResult.data.Dictations;
            this.showLoader = false;
            this.patientTranscribeListFlag = true;
          }
        },
        (err) => {
          this.showLoader = false;
          console.error(err);
        }
      );
    this.showLoader = false;
  }

  openReplyModal(commentId) {
    this.selectedComment = this.dictationList.find(
      (e) => e.CommentId == commentId
    );
  }

  openActionCommentModal() {
    this.showActionCommentModal = true;
  }

  closeActionCommentModal() {
    this.showActionCommentModal = false;
  }

  findAdminList() {
    this.admins = [];

    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      loggedInUserId: this.loggedInUserId,
      userRoleVal: 1,
    };
    this.http
      .post(
        // this.appConfig.getPhpUrl() + ApiHelper.php_getAdminUsersListApi,
        this.appConfig.getLambdaUrl06() + ApiHelper.getAdminUsersList,
        finalData,

        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          this.admins = this.resultJsonObj.commandResult.data.adminUsers;
        },
        (err) => { }
      );
  }

  showData(value: any) {
    this.showDataVal = value;
    if (value == 2) {
      this.findSharedDictationSummaries();
    } else {
      this.findDictations();
    }
  }

  async goToDemographics() {
    // this.router.navigate([
    //   "/" + this.childRoute + "/demographics/" + this.loggedInUserId,
    // ]);
    // // }
    this.location.back();
  }

  openMp3FIle(recordingUrl: string): void {
    if (recordingUrl) {
      window.open(recordingUrl, "_blank");
    } else {
      console.error("Recording URL is not available.");
    }
  }

  openTranscript(TranscriptUrl: string): void {
    if (TranscriptUrl) {
      window.open(TranscriptUrl, "_blank");
    } else {
      console.error("Transcript URL is not available.");
    }
  }

  openPrescription(prescriptionUrl: string): void {
    // alert(prescriptionUrl)
    if (prescriptionUrl) {
      window.open(prescriptionUrl, "_blank");
    } else {
      console.error("Prescription URL is not available.");
    }
  }

  openFollowUpNotes(followUpNotesUrl: string): void {
    // alert(followUpNotesUrl)
    if (followUpNotesUrl) {
      window.open(followUpNotesUrl, "_blank");
    } else {
      console.error("Follow up URL is not available.");
    }
  }

  openAppointmentScheduling(appointmentSchedulingUrl: string): void {
    // alert(appointmentSchedulingUrl)
    if (appointmentSchedulingUrl) {
      window.open(appointmentSchedulingUrl, "_blank");
    } else {
      console.error("Appointment scheduling URL is not available.");
    }
  }

  openSummary(SummaryUrl: string): void {
    if (SummaryUrl) {
      window.open(SummaryUrl, "_blank");
    } else {
      console.error("Summary URL is not available.");
    }
  }

  openTemplate(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }




  encodeFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result.split(",")[1]);
        } else {
          reject(new Error("FileReader returned a non-string result"));
        }
      };
      reader.onerror = (error) => reject(error);
    });
  };



  async regenerateTranscript(recordingUrl: string, commentId: any) {
    try {
      sessionStorage.setItem('transcribeStatus', 'pending');
      // Save the ongoing process data in sessionStorage
      sessionStorage.setItem('transcriptionInProgress', JSON.stringify({ recordingUrl, commentId }));

      const response = await fetch(recordingUrl);
      const blobData = await response.blob();
      const formData = new FormData();
      formData.append("audio", blobData, "audio.mp3");
      const physicianName = localStorage.getItem('loggedInUserName');
      formData.append("doctorName", physicianName);
      formData.append("patientName", this.patientName);
      console.log("patient name: ", this.patientName);
      console.log("doctor: ", physicianName);
      if (this.transcribeApiUrl) {
        this.updateRecordStatus(commentId, 'pending');
        const apiResponse = await this.http.post<any>(this.transcribeApiUrl, formData).toPromise();
        console.log("apiResponse: ", apiResponse)
        if (apiResponse) {
          let { original_text_content, summary } = apiResponse;
          // original_text_content = original_text_content.replace(/{|}/g, '').replace(/```/g, '')                
          // .replace(/"example_output":*/g, '')   // Remove the "example output" label                         
          console.log("original_test_content: ", original_text_content)
          // if (original_text_content.includes("Person1") || original_text_content.includes("Person2")) {                    
          console.log("summary: ", summary)
          const originalTextBlob = new Blob([original_text_content], { type: "text/plain" });
          const summaryBlob = new Blob([summary], { type: "text/plain" });

          const transcriptFile = new File([originalTextBlob], `transcription.txt`, { type: "text/plain" });
          const summaryFile = new File([summaryBlob], `summary.txt`, { type: "text/plain" });

          const transcriptBase64 = await this.encodeFileToBase64(transcriptFile);
          const summaryBase64 = await this.encodeFileToBase64(summaryFile);

          const SecondJsonData = {
            company_slug: ConstantHelper.COMPANY_SLUG,
            physician_id: this.loggedInUserId,
            patient_id: this.demographyUserId,
            chat_id: "",
            audioKey: { filename: "", content: "" },
            transcriptKey: { filename: transcriptFile.name, content: transcriptBase64 },
            summaryKey: { filename: summaryFile.name, content: summaryBase64 },
          };

          let sls06baseurl = environment.lambdaApiUrl_06;
          let apiurlphp = sls06baseurl + ApiHelper.uploadRecording;
          let secondResult = await axios.post(`${apiurlphp}`, SecondJsonData);

          if (secondResult.data && secondResult.data.commandResult && secondResult.data.commandResult.data) {
            let secondUrl = secondResult.data.commandResult.data;

            const updateDictationUrls = {
              commentId: commentId,
              transcriptUrl: secondUrl.transcriptUrl,
              summaryUrl: secondUrl.summaryUrl,
            };

            let updateApiUrl = environment.lambdaApiUrl_05 + ApiHelper.updateComment;
            await axios.post(`${updateApiUrl}`, updateDictationUrls);
            this.updateRecordStatus(commentId, 'success');
            window.dispatchEvent(new CustomEvent('transcribeStatusUpdate', {
              detail: {
                status: 'success',
                transcriptUrl: secondUrl.transcriptUrl,
                message: 'Transcribe is ready'
              }
            }));
            // } 
            // else {
            //     this.handleError(commentId, "Invalid response structure from second API call", secondResult);
            // }
          } else {
            this.handleError(commentId, "Missing original_text_content or summary in API response", apiResponse);
          }
        } else {
          this.handleError(commentId, "API response is null or undefined", apiResponse);
        }
      } else {
        this.handleError(commentId, "Transcribe API URL is not defined", null);
      }

      // Clear the session storage after successful completion
      sessionStorage.removeItem('transcriptionInProgress');
    } catch (error) {
      this.handleError(commentId, "Error during API call", error);
    }
  }

  async fetchUserDetails(id: string, type: 'patient' | 'physician'): Promise<any> {
    const payload = { id };

    try {
      const res: any = await this.http
        .post(this.appConfig.getLambdaUrl05() + ApiHelper.getUserDetail, payload)
        .toPromise();

      // if (res?.commandResult?.status === 1 && res.commandResult.data?.userInfo) {
      if (res && res.commandResult && res.commandResult.status === 1 && res.commandResult.data && res.commandResult.data.userInfo) {
        const user = res.commandResult.data.userInfo;
        console.log(`${type} details fetched:`, user);

        return {
          name: user.FullName || '',
          phone: user.Mobile || '',
          email: user.Email || '',
          address: user.Address || 'N/A',
          allergies: user.Allergies || 'None',
          dob: user.DOB_Year + '-' + user.DOB_Month + '-' + user.DOB_Date,
          gender: user.Gender || 'N/A',
        };
      } else {
        throw new Error(`Failed to fetch ${type} details`);
      }
    } catch (err) {
      console.error(`Error fetching ${type} details:`, err);
      return null;
    }
  }



  async generateTemplates(recordingUrl: string, commentId: any) {
    try {

      const response = await fetch(recordingUrl);
      const blobData = await response.blob();
      const formData = new FormData();
      formData.append("audio", blobData, "audio.mp3");
      // formData.append("audio", audioBlob, fileName);
      const physicianName = localStorage.getItem('loggedInUserName');
      const physicianId = localStorage.getItem('loggedInUserId');
      const patientId = sessionStorage.getItem('patientId');
      formData.append("companyName", this.comapnyName)
      formData.append("doctorName", physicianName);
      formData.append("patientName", this.patientName);



      // Call both in parallel
      const [patient, physician] = await Promise.all([
        this.fetchUserDetails(patientId, 'patient'),
        this.fetchUserDetails(physicianId, 'physician')
      ]);

      console.log("patient details: ", patient)
      console.log("physician details: ", physician)

      if (patient && physician) {
        // 👇 Now append to formData
        formData.append("patientName", patient.name);
        formData.append("patientPhone", patient.phone);
        formData.append("patientEmail", patient.email);
        formData.append("patientAddress", patient.address);
        formData.append("patientAllergies", patient.allergies);
        formData.append("patientDOB", patient.dob);


        formData.append("doctorName", physician.name);
        formData.append("doctorPhone", physician.phone);
        formData.append("doctorEmail", physician.email);

      }

      const selectedTemplateNames: string[] = [];

      // ✅ Add dynamic template fields
      for (const template of this.enabledTemplates) {
        const isSelected = this.selectedTemplates[template.id];
        const fieldKey = 'generate_' + template.template_name.toLowerCase().replace(/\s+/g, '_');

        formData.append(fieldKey, isSelected ? 'true' : 'false');

        if (isSelected) {
          selectedTemplateNames.push(template.template_name);
        }
      }

      // Optional: Also send names array
      formData.append("selectedTemplates", JSON.stringify(selectedTemplateNames));
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-'); // Format: 2025-06-18T08-23-45-123Z
      const fileName = `${this.patientName}_${this.physicianName}_${this.comapnyName}_${timestamp}`;

      if (this.pdfTemplateUrl) {
        this.updateRecordStatus(commentId, 'pending');
        const apiResponse = await this.http.post<any>(this.pdfTemplateUrl, formData).toPromise();
        console.log("apiResponse: ", apiResponse)
        if (apiResponse) {
          let { original_text_content, summary, prescription, follow_up, appointment } = apiResponse;

          console.log("original_test_content: ", original_text_content)
          console.log("summary: ", summary)
          const originalTextBlob = new Blob([original_text_content], { type: "text/plain" });
          const summaryBlob = new Blob([summary], { type: "text/plain" });

          const transcriptFile = new File([originalTextBlob], `transcription.txt`, { type: "text/plain" });
          const summaryFile = new File([summaryBlob], `summary.txt`, { type: "text/plain" });

          const transcriptBase64 = await this.encodeFileToBase64(transcriptFile);
          const summaryBase64 = await this.encodeFileToBase64(summaryFile);

          const response = await fetch(prescription); // This is your https://abc.blob.core.../output1.pdf
          const blob = await response.blob();

          // Step 2: Create a File object from the blob
          const prescriptionFile = new File([blob], `${fileName}_prescription.pdf`, {
            type: 'application/pdf',
          });
          console.log("prescription File: ", prescriptionFile)

          const response2 = await fetch(follow_up); // This is your https://abc.blob.core.../output1.pdf
          const follow_up_blob = await response2.blob();
          // Step 2: Create a File object from the blob
          const followUpNotesFile = new File([follow_up_blob], `${fileName}_follow_up_notes.pdf`, {
            type: 'application/pdf',
          });
          console.log("follow up File: ", followUpNotesFile)

          const response3 = await fetch(appointment); // This is your https://abc.blob.core.../output1.pdf
          const appointment_blob = await response3.blob();
          // Step 2: Create a File object from the blob
          const appointmentSchedulingFile = new File([appointment_blob], `${fileName}_appointment_scheduling.pdf`, {
            type: 'application/pdf',
          });
          console.log("appointment scheduling File: ", appointmentSchedulingFile)

          const prescriptionBase64 = await this.encodeFileToBase64(prescriptionFile);
          const followUpNotesBase64 = await this.encodeFileToBase64(followUpNotesFile);
          const appointmentSchedulingBase64 = await this.encodeFileToBase64(appointmentSchedulingFile);


          const SecondJsonData = {
            company_slug: ConstantHelper.COMPANY_SLUG,
            physician_id: this.loggedInUserId,
            patient_id: this.demographyUserId,
            chat_id: "",
            audioKey: { filename: "", content: "" },
            transcriptKey: { filename: transcriptFile.name, content: transcriptBase64 },
            summaryKey: { filename: summaryFile.name, content: summaryBase64 },
            prescriptionKey: { filename: prescriptionFile.name, content: prescriptionBase64 },
            followUpNotesKey: { filename: followUpNotesFile.name, content: followUpNotesBase64 },
            appointmentSchedulingKey: { filename: appointmentSchedulingFile.name, content: appointmentSchedulingBase64 }
          };

          let sls06baseurl = environment.lambdaApiUrl_06;
          let apiurlphp = sls06baseurl + ApiHelper.uploadRecording;
          let secondResult = await axios.post(`${apiurlphp}`, SecondJsonData);

          if (secondResult.data && secondResult.data.commandResult && secondResult.data.commandResult.data) {
            let secondUrl = secondResult.data.commandResult.data;

            const updateDictationUrls = {
              commentId: commentId,
              transcriptUrl: secondUrl.transcriptUrl,
              summaryUrl: secondUrl.summaryUrl,
              prescriptionUrl: secondUrl.prescriptionUrl,
              followUpNotesUrl: secondUrl.followUpNotesUrl,
              appointmentSchedulingUrl: secondUrl.appointmentSchedulingUrl
            };

            let updateApiUrl = environment.lambdaApiUrl_05 + ApiHelper.updateComment;
            await axios.post(`${updateApiUrl}`, updateDictationUrls);
            this.updateRecordStatus(commentId, 'success');
            // this.handleError(commentId, "Invalid response structure from second API call", secondResult);

            return {
              summaryUrl: secondUrl.summaryUrl,
              prescriptionUrl: secondUrl.prescriptionUrl,
              followUpNotesUrl: secondUrl.followUpNotesUrl,
              appointmentSchedulingUrl: secondUrl.appointmentSchedulingUrl
            };
          }
        }
      }




    } catch (error) {
      this.handleError(commentId, "Error during API call", error);
    }
  }

  updateRecordStatus(commentId: any, status: 'pending' | 'success' | 'error') {
    const record = this.dictationList.find(record => record.CommentId === commentId);
    if (record) {
      record.Status = status;
      // this.zone.run(() => this.cdr.detectChanges()); // Trigger change detection
      this.zone.run(() => {
        if (!this.isDestroyed) {
          this.cdr.detectChanges();
        }
      });
    }
  }

  fetchText(fileUrl: any) {
    this.textService.getTextFromUrl(fileUrl).subscribe(
      (response: string) => {
        this.fetchedText = response;
      },
      (error) => {
        console.error("Error fetching text:", error);
      }
    );
  }

  openEditPopup() {    
    this.showEditsummaryModal = true;
    this.getEnabledTemplates();
  }

  showAiSummaryModalPopup() {
    this.showAiSummaryModal = true;
  }

  showSignedAiSummaryModalPopup() {
    this.showSignedAiSummaryModal = true;
  }

  closeEditModal() {
    this.editSummaryFlag = false;
    this.showEditsummaryModal = false;
    this.showAiSummaryModal = false;
    this.showShareSummaryModal = false;
    this.showSignedAiSummaryModal = false;

  }

  closeAiDictationModal() {
    this.showAiDictationModalPopup = false;
    this.findDictations();
  }

  editSummaryFlagCondition() {
    this.editSummaryFlag = !this.editSummaryFlag;
  }

  setCommentId(recordingUrl: any, commentId: any) {    
    this.recordingUrl = recordingUrl;
    this.commentId = commentId;
  }

  generateTxtFile(text: string): Blob {
    const newText = `${text}`;
    const blob = new Blob([newText], { type: "text/plain" });
    return blob;
  }

  async uploadToAzure(value) {
    try {
      if (value == 0) {
        const txtBlob = this.generateTxtFile(this.fetchedText);
        if (!txtBlob) {
          throw new Error("Failed to generate text blob");
        }

        const alertStatus = await this.sweetAlertHelper.confirmPopUp(
          "Please Confirm",
          "Must sign prior to share"
        );
        if (alertStatus) {
          this.isSummaryEdited = 1;
          const editedBy = localStorage.getItem("loggedInUserName");
          const summaryFile = new File(
            [txtBlob],
            `summary_edited_by_${editedBy}.txt`,
            { type: "text/plain" }
          );
          const azureBody = new FormData();
          azureBody.append("fileKey", summaryFile);
          azureBody.append("loggedInUserId", this.loggedInUserId);
          const azureApiUrl =
            this.appConfig.getPhpUrl() + ApiHelper.php_uploadAzureFile;
          const res = await axios.post(azureApiUrl, azureBody, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (res.data) {
            const fileUrl = res.data.commandResult.data.fileUrl;
            await this.updateEditedSummaryUrl(fileUrl);
          }
        } else {
          return false;
        }
      } else if (value == 1) {
        const txtBlob = this.generateTxtFile(this.fetchedText);
        var txtBlobText = await (txtBlob as any).text();
        if (!txtBlob) {
          throw new Error("Failed to generate text blob");
        }

        const alertStatus = await this.sweetAlertHelper.confirmPopUp(
          "Please Confirm",
          "I previewed this document electronically and signed. Please note, one electronically signed, this will be read only."
        );
        if (alertStatus) {
          this.isSummaryEdited = 1;
          this.isSummarySigned = 1;
          //template code commented starts
          // const selectedTemplates = {
          //   prescription: this.prescriptionTemplate,
          //   followUp: this.followUpTemplate,
          //   appointment: this.appointmentTemplate,
          // };
          try {
          //   this.showLoader = true;
          //   const result = await this.generateTemplates(this.recordingUrl, this.commentId);
          //   console.log("result......", result)
          //   if (result) {
          //     console.log("Prescription URL:", result.prescriptionUrl);
          //     console.log("Follow Up URL:", result.followUpNotesUrl);
          //     console.log("Appointment URL:", result.appointmentSchedulingUrl);
          //   }
          //   this.showLoader = false;
          //   const physicianRoleKey = this.availableRoles.find(r => r.toLowerCase() === "physician");
          //   const patientRoleKey = this.availableRoles.find(r => r.toLowerCase() === "patient");

          //   if (physicianRoleKey && (!this.roleEmails[physicianRoleKey] || !this.roleEmails[physicianRoleKey].includes("@"))) {
          //     const physicianEmail = localStorage.getItem("loggedInUserEmail");
          //     if (physicianEmail && physicianEmail.includes("@")) {
          //       this.roleEmails[physicianRoleKey] = physicianEmail.trim();
          //     }
          //   }

          //   if (patientRoleKey && (!this.roleEmails[patientRoleKey] || !this.roleEmails[patientRoleKey].includes("@"))) {
          //     const patientEmail = localStorage.getItem("patientEmail");
          //     if (patientEmail && patientEmail.includes("@")) {
          //       this.roleEmails[patientRoleKey] = patientEmail.trim();
          //     }
          //   }

          //   // ✅ Step 1: Gather all unique email addresses
          //   const emailSet = new Set<string>();
          //   this.availableRoles.forEach(role => {
          //     const email = this.roleEmails[role];
          //     if (email && email.includes("@")) {
          //       emailSet.add(email.trim());
          //     }
          //   });
          //   // ✅ Step 2: Add logged-in physician and patient emails from localStorage
          //   const physicianEmail = localStorage.getItem("loggedInUserEmail");
          //   const patientEmail = localStorage.getItem("patientEmail");
          //   console.log("physicianEmail: ", physicianEmail)
          //   if (physicianEmail && physicianEmail.includes("@")) {
          //     emailSet.add(physicianEmail.trim());
          //   }
          //   if (patientEmail && patientEmail.includes("@")) {
          //     emailSet.add(patientEmail.trim());
          //   }

          //   // ✅ Final array for payload
          //   const emailList = Array.from(emailSet);
          //   console.log("emailList....", emailList)


          //   // // Step 2: Prepare payload for your serverless API
          //   // const payload = {
          //   //   emailList: emailList,
          //   //   templateUrls: {
          //   //     prescription: result.prescriptionUrl,
          //   //     followUpNotes: result.followUpNotesUrl,
          //   //     appointment: result.appointmentSchedulingUrl
          //   //   }
          //   // };
          //   // console.log("Email payload...", payload)

          //   // Step 2: Map templates per email based on checkbox selections
          //   const templatesPerEmail: any = {};

          //   for (const t of this.enabledTemplates) {
          //     const templateId = t.id;
          //     const templateName = t.template_name.toLowerCase();

          //     this.availableRoles.forEach(role => {
          //       //const email = this.roleEmails[role]?.trim();
          //       const email = this.roleEmails && this.roleEmails[role] ? this.roleEmails[role].trim() : null;
          //       const isTemplateChecked = this.selectedTemplates[templateId];
          //       const isRoleChecked = this.roleSelections &&
          //         this.roleSelections[templateId] &&
          //         this.roleSelections[templateId][role];
          //       // Ensure both email and checkbox for this role & template are selected
          //       // if (email && email.includes("@") && isTemplateChecked && isRoleChecked) {
          //       if (email && isTemplateChecked && isRoleChecked) {
          //         console.log("✅ Mapping for:", email, templateName);
          //         // Initialize structure
          //         if (!templatesPerEmail[email]) {
          //           templatesPerEmail[email] = {
          //             email,
          //             templates: {}
          //           };
          //         }

          //         // Map the correct template URL
          //         if (templateName.includes('prescription')) {
          //           templatesPerEmail[email].templates.prescription = result.prescriptionUrl;
          //         } else if (templateName.includes('follow')) {
          //           templatesPerEmail[email].templates.followUpNotes = result.followUpNotesUrl;
          //         } else if (templateName.includes('appointment')) {
          //           templatesPerEmail[email].templates.appointment = result.appointmentSchedulingUrl;
          //         }
          //       }
          //     });
          //   }

          //   // Step 3: Build final payload
          //   const payload = {
          //     emailList,
          //     templatesPerEmail
          //   };

          //   console.log("Final Email Payload", payload);


          //   // Step 3: Make the POST request
          //   try {
          //     let sls06baseurl = environment.lambdaApiUrl_06;
          //     let apiUrl = sls06baseurl + ApiHelper.sendEmailTemplate;
          //     const res = await axios.post(apiUrl, payload);
          //     console.log("res...", res)
          //     const result = res.data.commandResult;

          //     if (result && result.success === 1) {
          //       console.log("✅ Email sent successfully:", result.message);
          //     } else {
          //       // console.warn("Email service returned failure:", res.data && res.data.message);
          //       const fallbackMessage =
          //         result.message || result.data.message || "Unknown error occurred";
          //       console.warn("⚠️ Email service returned failure:", fallbackMessage);
          //     }
          //   } catch (emailErr) {
          //     console.error("Failed to send email:", emailErr);
          //   }


              const today = new Date();
              
                const options: Intl.DateTimeFormatOptions = {
                  timeZone: "America/New_York",
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true
                };

                const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(today);
                console.log(formattedDate);
              const signedBy = localStorage.getItem("loggedInUserName");
              //const selectedTypes = Object.entries(selectedTemplates)
                // .filter(([_, value]) => value)
                // .map(([key]) => key)
                // .join(', ');
                const finalText = `${txtBlobText}\n\n\nThis is electronically signed document\nSigned By: Dr. ${signedBy}\nDate: ${formattedDate} 
            `;
            //   const finalText = `${txtBlobText}\n\n\nThis is electronically signed document\nSigned By: Dr. ${signedBy}\nDate: ${formattedDate} with below selected templates, 
            // Templates Generated:  ${selectedTypes} \n\n
            // `;
              console.log("final text: ", finalText)
              const summaryFile = new File(
                [finalText],
                `summary_signed_by_${signedBy}.txt`,
                { type: "text/plain" }
              );
              const azureBody = new FormData();
              azureBody.append("fileKey", summaryFile);
              azureBody.append("loggedInUserId", this.loggedInUserId);
              const azureApiUrl =
                this.appConfig.getPhpUrl() + ApiHelper.php_uploadAzureFile;
              const res = await axios.post(azureApiUrl, azureBody, {
                headers: { "Content-Type": "multipart/form-data" },
              });
              if (res) {
                console.log("res...",res)
                const fileUrl = res.data.commandResult.data.fileUrl;
                console.log("fileUrl....",fileUrl)
                await this.updateEditedSummaryUrl(fileUrl);
              }
          } catch (error) {
            console.error("Error generating templates:", error);
            alert("Failed to generate templates. Please try again.");
          }
        } else {
          return false;
        }
      }
    } catch (err) {
      console.error("Error uploading to Azure:", err);
    }
  }

  async updateEditedSummaryUrl(fileUrl) {

    const finalData = {
      commentId: this.commentId,
      editedSummaryUrl: fileUrl,
      isSummaryEdited: this.isSummaryEdited,
      isSummarySigned: this.isSummarySigned,
    };
    console.log("finalData....",finalData)
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.updateDictationSummary,
        finalData,
        this.httpOptions
      )
      .subscribe(
        async (res: any) => {
          console.log("in api res..",res)
          this.showLoader = false;
          this.showEditsummaryModal = false;
          window.location.reload();
        },
        (err) => {
          this.showLoader = false;
          console.error(err);
        }
      );
  }

  findSharedDictationSummaries() {
    this.sharedDictationList = [];
    this.dictationList = [];
    this.patientTranscribeListFlag = false;
    let finalData: { receivingPhysicianId: string; patientId: string };
    if (this.isDelegating == 1) {
      finalData = {
        receivingPhysicianId: this.delegateId,
        patientId: this.demographyUserId,
      };
    } else {
      finalData = {
        receivingPhysicianId: localStorage.getItem("loggedInUserId"),
        patientId: this.demographyUserId,
      };
    }

    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() +
        ApiHelper.fetchPhysicianSharedDictationSummary,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (res: any) => {
          if (res.commandResult.data.SummaryDetails.length > 0) {
            this.sharedDictationList = res.commandResult.data.SummaryDetails;
            this.showLoader = false;
            this.shareVisitSummariesFlag = true;
          }
        },
        (err) => {
          this.showLoader = false;
          console.error(err);
        }
      );
    this.showLoader = false;
  }

  // SHare with physicianas code

  openShareSummaryModal() {
    this.showShareSummaryModal = true;
  }

  onChangePractice(companyUrl) {
    const reqData = {
      company_slug: companyUrl,
      loggedInUserId: this.demographyUserId,
    };

    this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_findUserDoctorsByPracticeApi,
        reqData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.physicians1 = apiResponse.commandResult.data.companiesList;
        },
        (err) => { }
      );
  }

  getUserPractices() {
    const finalData = {
      loggedInUserId: this.demographyUserId,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_findUserPracticeApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.practices = apiResponse.commandResult.data.companiesList;
          this.showLoader = false;
        },
        (err) => {
          console.error(err);
        }
      );
  }

  async listData() {
    if (this.physicianInfo1.length <= 0) {
      await this.sweetAlertHelper.alertPopUp(
        "Please select practice or physician"
      );
      return false;
    }
    if (this.physicianInfo1 == "all") {
      this.tempPractice01.push(
        this.practices.find((x) => x.company_url == this.practiceInfo1)
      );
    } else {
      this.physicianInfo1.forEach((element) => {
        const existingPhysician = this.finalPhysician01.find(
          (x) => x.physician_id == element
        );
        if (!existingPhysician) {
          const selectedPhysician = this.physicians1.find(
            (x) => x.physician_id == element
          );
          if (selectedPhysician) {
            this.finalPhysician01.push(selectedPhysician);
            this.tempPhysician01.push(selectedPhysician);

            this.selectedPhysiciansIdList.push(selectedPhysician.physician_id);
          }
        }
      });
    }
  }

  onChangePhysician(value, j) {
    if (value == "all" && j == 0) {
    }
    if (value == "all" && j == 1) {
    }
    if (value == "all" && j == 2) {
    }
    if (value == "all" && j == 3) {
    }
    if (value == "all" && j == 4) {
    }
  }

  shareSummaryWithPhysician() {
    const finalData = {
      patientId: this.demographyUserId,
      sendingPhysicianId: localStorage.getItem("loggedInUserId"),
      receivingPhysicianId: this.selectedPhysiciansIdList,
      dictationSummaryId: this.commentId,
    };

    console.log("finalData: ", finalData)
    // return
    this.showLoader = true;

    this.http
      .post(
        this.appConfig.getLambdaUrl05() +
        ApiHelper.postPhysicianSharedDictationSummary,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          if (apiResponse.commandResult.status == 1) {
            this.showShareSummaryModal = false;
            this.selectedPhysiciansIdList = [];
          }
          this.showLoader = false;
        },
        (err) => {
          // console.error(err);
        }
      );
  }

  showAiDictationModal() {
    this.showAiDictationModalPopup = true;
    this.chatBotVisible = true;
    this.patientId = this.demographyUserId; // Set patientId based on your logic
    this.isPopUp = true; // Set isPopUp to true
    this.isDictationUploaded = false;
    this.isDictationStarted = false;
  }

  // Function to update flag from React when dictation is uploaded
  handleDictationUploadSuccess() {
    this.isDictationUploaded = true;
  }
  async openDictationWindow() {
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.dictationConfirmComp.dictationModal
    );
    if (alertStatus) {
      this.router.navigate(
        ["/" + this.childRoute + "/ahsgpt/" + this.loggedInUserId],
        { queryParams: { isPopUp: true, patientId: this.demographyUserId } }
      );
    }
  }


  private handleError(commentId: any, errorMessage: string, errorDetails: any) {
    console.error(errorMessage, errorDetails);
    this.updateRecordStatus(commentId, 'error');
    window.dispatchEvent(new CustomEvent('transcribeStatusUpdate', {
      detail: {
        status: '400 bad request',
        message: 'Unable to understand audio... Failed to generate Transcribe'
      }
    }));
    sessionStorage.removeItem('transcriptionInProgress');
  }


  ngOnDestroy() {
    this.isDestroyed = true;
    // Remove the event listener when the component is destroyed
    window.removeEventListener("transcribeStatusUpdate", (event: any) => { });
  }



  //////////////////////////////////////////////////////////////////////////////////////////////////
}
